module.exports = __webpack_public_path__ + "static/media/spring_icon_store.7a914e3d.png";